module.exports = __webpack_public_path__ + "media/images/OPL 66-ab359f272137126f3ac8c02a467d3b91.png";